// ListView
// Accepts a filter, then fetches it
//
// Utitlizes endless scrolling pagination pattern
//
// Future bug that loading thousands of items could be bad
// instituting a max-size & adjustable filter to allow
// discover would be good
//
const container_template = `
<section{{#if no_controls}} class="no-controls"{{/if}}>
    <div class="header">
        <h1 class="title">{{title}}</h1>
        <div class="create-item-region"></div>
    </div>
    <div class="controls">
        <div class="search-region"></div>
    </div>
</section>
<div class="alerts"></div>
<div class="loading-region"><div class="loading fa fa-cog fa-spin"/></div>
<div class="content-region list"></div>
<div class="info-region"></div>
<div class="arrow-up text-large fa fa-arrow-circle-up"/>`;

import Radio from 'backbone.radio';
import Backbone from 'backbone';
import Marionette from 'backbone.marionette';
import Handlebars from 'handlebars';
import ResponseResultsView from '@/views/response_results_view';
import AlertMixin from '@/mixins/alert';
// import ItemLookup from '@/views/item_lookup'; 
import Api from '@/lib/api/api';

const globalCh = Radio.channel('global');
const apiCh = Radio.channel('api');

let belongs = function(v5_object, request_data){
    let keys = Object.keys(request_data);
    let i_belong = true;
    keys.forEach( function(k) {
        if ( k.indexOf('filter') > -1 ) {
            switch ( k ) {
                case 'filter[product.id]':
                    if ( v5_object.rel && v5_object.rel.get('product')
                        && v5_object.rel.get('product').id === request_data[k] ) break;
                    i_belong = false;
                    break;
                case 'filter[owner.id]':
                    if ( v5_object.rel && v5_object.rel.get('owner')
                        && v5_object.rel.get('owner').id === request_data[k] ) {
                        break;
                    }
                    i_belong = false;
                    break;
                case 'filter[type]': {
                    let types = request_data[k].split(',');
                    let one_match = false;
                    types.forEach(
                        function(t){
                            if ( t === v5_object.type ) {
                                one_match = true;
                            }
                        }
                    );
                    if ( one_match === true ) {
                        break;
                    }
                    i_belong = false;
                    break;
                }
            }
        }
    });
    return i_belong;
};

var ListView = Marionette.CollectionView.extend({
    className: 'list-view',
    initialize: function() {
        this.request_data = this.getOption('request_data');
    },
    onRender: function() {},
    arrow_up: function(show) {
        this.triggerMethod('childview:arrow_up', show);
        return show;
    },
    loading: function(show) {
        this.triggerMethod('childview:show_loading', show);
        return show;
    },
    prev_url: undefined,
    next_url: undefined,
    request_data: undefined,
    fetch_list: function() {
        let self = this;
        if (!this.options.store) return;
        function the_url(){
            if ( !self.next_url ) {
                return self.options.store.url();
            } else {
                return self.next_url;
            }
        }
        if ( this.next_url === 'finished' ) {
            // when we can fetch no more, don't
            // maybe there is something nicer
            // that could be done at this point
            // in UI as to next possible steps
            // a user could take, in case they
            // didn't find what they want
            return;
        }
        let request_data = this.options.request_data;
        if ( this.next_url ) request_data = {};
        this.loading(true);
        this.stopListening(this.options.store);
        this.options.store
            .fetch({
                url: the_url(),
                data: request_data,
                wait: true
            })
            .then(function(resp){
                    if ( resp.data && resp.data.length && resp.data.length > 0 ) {
                        resp.data.forEach(function(item){ 
                            let g = apiCh.request(item.type, item.id);
                            self.collection.push(g, {merge: true});
                        });
                    }
                    if ( this.collection.length === 0) {
                        this.triggerMethod('childview:empty', true);
                        this.loading(false);
                        this.start_listeners();
                        return;
                    }
                    if (resp.links.next) {
                        this.next_url = resp.links.next;
                    } else {
                        this.next_url = 'finished';
                    }
                    this.loading(false);
                    this.start_listeners();
                }.bind(this),
                function(err){
                    this.loading(false);
                    this.triggerMethod('childview:error', err);
                }.bind(this)
            );
    },
    fetch_search_list(resp) {
        this.loading(true);
        this.stopListening(this.options.store);
        let self = this;
        if ( resp.devicegroups && resp.devicegroups.length && resp.devicegroups.length > 0 ) {
            resp.devicegroups.forEach(function(item){
                let g = apiCh.request(item.t + "_devicegroup", { id: item.i });
                g.type = item.t + '_devicegroup';
                self.collection.push(g, {merge: true});
            });
        }
        if ( this.collection.length === 0) {
            this.triggerMethod('childview:empty', true);
            this.loading(false);
            this.start_listeners();
            return;
        }

        this.loading(false);
    },
    start_listeners: function() {
        this.listenTo(this.options.store, 'add', function(model){
            if ( model
                 && !this.collection.contains(model)
                 && belongs(model, this.request_data) ) {

                this.collection.add(model, { at: 0, merge: true});
                this.triggerMethod('childview:empty', false);
            }
        }.bind(this));
        this.listenTo(this.options.store, 'remove', function(model){
            if ( this.collection.contains(model) ) {
                this.collection.remove(model);
                if ( this.collection.length < 1 ) {
                    this.triggerMethod('childview:empty', true);
                }
            }
        }.bind(this));
    }
});

let list_collection = Backbone.Collection.extend({
    parse: Api.parse_collection
});

var ContainerView = Marionette.View.extend(AlertMixin).extend({
    className: function(){
        if ( this.options.card_list == true ) {
            return 'standard-layout card-list';
        } else {
            return 'standard-layout';
        }
    },
    template: Handlebars.compile(container_template),
    ui: {
        bulk_controls: '.controls > .group',
        pagination_controls: '.controls > .pagination',
        controls: '.controls',
        create_button: '.create-item-region',
        alerts: '.alerts',
        content: '.content-region',
        blinkup_page: '.blinkup-page',
        loading_region: '.loading-region',
        arrow_up: '.arrow-up',
        info_region: '.info-region',
        search_region: '.search-region'
    },
    regions: {
        bulk_controls: '@ui.bulk_controls',
        pagination_controls: '@ui.pagination_controls',
        controls: '@ui.controls',
        create_button: '@ui.create_button',
        alerts: '@ui.alerts',
        content: '@ui.content',
        info_region: '@ui.info_region',
        list_region: '@ui.list_region',
        loading_region: '@ui.loading_region',
        search_region: '@ui.search_region'
    },
    events: {
        'click @ui.arrow_up' : 'scroll_to_top',
        'click @ui.blinkup_page': function(e) { // to show blinkup from the button
            e.preventDefault();
            globalCh.request('show_blinkup');
        }
    },
    childViewEvents: {
        'childview:arrow_up' : 'arrow_up',
        'childview:show_loading' : 'show_loading',
        'childview:empty' : 'show_empty',
        'childview:error' : 'show_error',
        'childview:hide_error' : 'hide_error'
    },
    initialize: function() {
        globalCh.reply('layout_alert', this.alert.bind(this));
        this.list = new list_collection();
        if ( !this.options.type ) return;
        this.store = apiCh.request(this.options.type);
    },
    templateContext: function() {
        return {
            title: this.getOption('title') || 'Untitled',
            // In the case we are not wanting to show the
            // controls region, ie, no pagination, no buttons
            // in the group div. If no_controls evaluates to
            // true, the controls region will have a class
            // added to it.
            no_controls: this.getOption('no_controls') || false,
            show_blinkup: this.getOption('show_blinkup') || false
        };
    },
    store: undefined,
    list: undefined,
    onRender: function(){
        let self = this;
        let request_data = this.getOption('request_data');
        // set up filters for search
        // let search_request_data = {
        //     'o' : request_data['filter[owner.id]'],
        //     'p' : request_data['filter[product.id]'],
        //     't' : request_data['filter[type]']
        // };
        // // render search form
        // this.showChildView('search_region', new ItemLookup({
        //     className: 'menu-item',
        //     collection: this.store,
        //     request_data: search_request_data,
        //     title: 'Device Group Lookup',
        //     placeholder: 'Device Group ID, Name, SHA',
        //     autocomplete: 'off',
        //     action: function(resp) {
        //         self.hide_error();
        //         self.render_search_results(resp);
        //     }.bind(self),
        //     fail: function(err) {
        //         self.show_error(err);
        //     }.bind(self)
        // }));

        // perform default ListView fetch
        let list_view = new ListView({
            childView: this.getOption('child_view'),
            collection: this.list,
            store: this.store,
            request_data: request_data
        });

        this.arrow_up(false);
        this.showChildView('content', list_view);

        let create_button;

        if (this.options.create_button) {
            create_button = new this.options.create_button();
            this.showChildView('create_button', create_button);
            if (create_button.enabled === true) {
                create_button.enable();
            } else if (create_button.enabled === false) {
                create_button.disable();
            }
        }

        list_view.fetch_list();

        this.ui.content.scroll( null, function() {
            // this +1 is to deal with a weird issue where 
            // scroll height is often just 1px under the
            // amount needed to trigger the fetch
            if ( this.scrollHeight - this.scrollTop <= this.clientHeight + 1 ){
                list_view.fetch_list();
            }
            if ( this.scrollTop > 6 ) self.arrow_up(true);
            if ( this.scrollTop < 7 ) self.arrow_up(false);
        });
    },
    render_search_results: function(resp) {
        let search_list = new list_collection();
        if ( !resp.devicegroups ) {
            return;
        }
        let list_view = new ListView({
            childView: this.getOption('child_view'),
            collection: search_list,
            store: this.store,
            request_data: this.getOption('request_data')
        });
        this.arrow_up(false);
        this.showChildView('content', list_view);
        list_view.fetch_search_list(resp);
    },
    arrow_up: function(show){
        if (show) {
            this.ui.arrow_up.fadeIn(600);
            return true;
        }
        this.ui.arrow_up.fadeOut(60);
        return false;
    },
    scroll_to_top: function() {
        this.ui.content.animate({scrollTop: 0}, 300);
    },
    show_loading: function(show) {
        if (show) {
            this.ui.loading_region.show();
            return true;
        }
        this.ui.loading_region.hide();
        return false;
    },
    show_empty: function(show) {
        let request_data = this.getOption('request_data');
        if ( show || ( this.list && this.list.length === 0 ) ){
            var EmptyView = this.getOption('empty_view');
            var empty_view = new EmptyView({ product: this.getOption('product')});
            this.showChildView('content', empty_view);
            this.show_loading(false);
            this.listenTo(this.store, 'add', function(model){
                if ( belongs(model, request_data) ) this.render();
            }.bind(this));
        }
        return true;
    },
    show_error: function(err) {
        var response_results_view = new ResponseResultsView({
            resp: err,
        });
        this.ui.alerts.fadeIn(60);
        this.showChildView('alerts', response_results_view);
    },
    hide_error: function() {
        let alerts = this.getRegion('alerts');
        alerts.reset();
    }
});

export default ContainerView;

